import { api, tagTypes } from "./api";

type PaginationParams = {
  page?: number;
  limit?: number;
};

// Inject dashboard endpoints into the main API
export const dashboardApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // Placeholder existing endpoints (if used elsewhere)
    getDashboardStats: builder.query<any, void>({
      query: () => "/dashboard/stats",
      providesTags: [tagTypes.Dashboard],
    }),
    getRecentBookings: builder.query<any, void>({
      query: () => "/dashboard/recent-bookings",
      providesTags: [tagTypes.Dashboard],
    }),
    getRecentTransactions: builder.query<any, void>({
      query: () => "/dashboard/recent-transactions",
      providesTags: [tagTypes.Dashboard],
    }),

    // New: mirrors src/service/Dashboard.ts
    getArtisanDashboard: builder.query<any, void>({
      query: () => ({ url: "artisan/v1/dashboard", method: "GET" }),
      providesTags: [tagTypes.Dashboard],
    }),
    getUserDashboard: builder.query<any, void>({
      query: () => ({ url: "user/v1/dashboard", method: "GET" }),
      providesTags: [tagTypes.Dashboard],
    }),
    getBookingDashboard: builder.query<any, void>({
      query: () => ({ url: "booking/v1/admin/dashboard", method: "GET" }),
      providesTags: [tagTypes.Dashboard],
    }),
    getRecentDashboardBookings: builder.query<any, void>({
      query: () => ({
        url: "booking/v1/admin/dashboard/recent",
        method: "GET",
      }),
      providesTags: [tagTypes.Dashboard],
    }),
    getReferrals: builder.query<any, PaginationParams>({
      query: ({ page = 1, limit = 10 }) => ({
        url: `admin/v1/referral/leaderboard`,
        method: "GET",
        params: { page, limit },
      }),
      providesTags: [tagTypes.Referral],
    }),
    getTimeSeriesData: builder.query<
      any,
      { period: "daily" | "weekly" | "monthly" }
    >({
      query: ({ period }) => ({
        url: `booking/v1/admin/dashboard/analytics?period=${period}`,
        method: "GET",
      }),
      providesTags: [tagTypes.Dashboard],
    }),
  }),
});

export const {
  useGetDashboardStatsQuery,
  useGetRecentBookingsQuery,
  useGetRecentTransactionsQuery,
  useGetArtisanDashboardQuery,
  useGetUserDashboardQuery,
  useGetBookingDashboardQuery,
  useGetRecentDashboardBookingsQuery,
  useGetReferralsQuery,
  useGetTimeSeriesDataQuery,
} = dashboardApi;
